/**
 * Hook for accessing funnel configuration
 */

import { useContext, createContext } from 'react';
import { FunnelConfig } from '@/config/types';

const FunnelConfigContext = createContext<FunnelConfig | null>(null);

export function FunnelConfigProvider({
  config,
  children,
}: {
  config: FunnelConfig;
  children: React.ReactNode;
}) {
  return (
    <FunnelConfigContext.Provider value={config}>
      {children}
    </FunnelConfigContext.Provider>
  );
}

export function useFunnelConfig(): FunnelConfig {
  const config = useContext(FunnelConfigContext);
  if (!config) {
    throw new Error('useFunnelConfig must be used within FunnelConfigProvider');
  }
  return config;
}
